import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InsuranceService } from 'src/app/_service/insurance.service';
import { SharedService } from 'src/app/_service/shared.service';

@Component({
  selector: 'app-addedit-insurance-company',
  templateUrl: './addedit-insurance-company.component.html',
  styleUrls: ['./addedit-insurance-company.component.css']
})
export class AddeditInsuranceCompanyComponent implements OnInit {

  insCompForm: FormGroup;submitted = false;loading:boolean=false;InsCompId: any = '';

  constructor(private formBuilder: FormBuilder, private activateRoute: ActivatedRoute, private insuranceService: InsuranceService, private sharedapi:SharedService, private router:Router) {
    this.insCompForm = this.formBuilder.group({
      'name': [null, Validators.required],
      'status': [null, Validators.required]
    });

    this.activateRoute.params.subscribe(params => {
      if(params['ins_comp_id']) {
        this.InsCompId = params['ins_comp_id'];
        this.patchInsCompanyData();
      }
    })
  }

  ngOnInit(): void {
  }

  get f() { return this.insCompForm.controls; }

  patchInsCompanyData(){
    this.insuranceService.getInsCompany(this.InsCompId).subscribe((response:any) => {
      if(response.status) {
        this.insCompForm.patchValue({
          'name': response.data.name,
          'status': response.data.status
        });
      }
    });
  }

  async createInsComp(){
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.insCompForm.invalid) {
        this.loading = false;
        return;
    }

    if(this.InsCompId) {
      this.insCompForm.value.id = parseInt(this.InsCompId);
      await this.insuranceService.updateInsCompany(this.insCompForm.value).subscribe((response:any) =>{
        this.submitted = false;
        this.loading = false;
        if(response.status) {
          this.sharedapi.presentToast('Insurance company Update Successfully');
          this.router.navigateByUrl('/insurance-company');
        } else {
          this.sharedapi.presentToast(response.msg);
        }
      }, error => {
          this.sharedapi.checkError(error);
      });
    } else {
      await this.insuranceService.addInsCompany(this.insCompForm.value).subscribe((response:any) =>{
        this.submitted = false;
        this.loading = false;
        if(response.status) {
          this.sharedapi.presentToast('Insurance company Added Successfully');
          this.router.navigateByUrl('/insurance-company');
        } else {
          this.sharedapi.presentToast(response.msg);
        }
      }, error => {
        this.sharedapi.checkError(error);
      });
    }
  }

}
